import { IConfig } from "~/config";
import { IStore } from "~/state/store";

export let store: IStore = null;
export let CONFIG: IConfig = null;
export let Scene: any = null;

export function setGlobals(global: {
	store: IStore;
	CONFIG: IConfig;
	Scene: any;
}) {
	store = global.store;
	CONFIG = global.CONFIG;
	Scene = global.Scene;
}
